module.exports = __webpack_public_path__ + "static/img/moaInstallForWin_pic10.cb2c608.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForWin/moaInstallForWin_pic10.png
// module id = 544
// module chunks = 1